import styles from './Footer.module.css';

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerWrapper}>
          copyright © 2022 Abu Shaqdam. All Rights Reserved.
        </div>
      </div>
    </footer>
  )
}
